// src/pages/GuestLoginPage.jsx
import { Typography, Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import WavingHandIcon from '@mui/icons-material/WavingHand';

const GuestLoginFailPage = () => {
  const { t } = useTranslation("common");

  return (
    <>
      <Typography variant="h4" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
        {t('guests.messages.login_fail')}
      </Typography>
      <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
        {t('guests.messages.login_fail_detail')}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "20vh" }}>
        <WavingHandIcon fontSize="large" color="error" />
      </Box>
    </>
  );
};

export default GuestLoginFailPage;